import moment from "moment";
import {
  Badge,
  CurrencyDisplay,
  OverflowMenuDropDown,
  OverflowMenuDropDownItem,
} from "../../components";
import { appConfig } from "../../configs";

import { paymentLinkStatus } from "../../enums";
import { IViewPaymentLink, StatusColors } from "../../interfaces-and-types";
import { formatAsCurrency, getPaymentLinkStatusIndicator } from "../../utils";
import { LinkUrlCopyDisplay } from "./LinkUrlCopyDisplay";

export const paymentLinksDisplayFormatter = (item: IViewPaymentLink) => {
  const statusIndicator = getPaymentLinkStatusIndicator(item);

  return {
    ...item,
    link_url: <LinkUrlCopyDisplay link={item.link_url_with_hostname} />,
    amount: (
      <strong>
        {item.currency} {formatAsCurrency(item.amount)}
      </strong>
    ),
    status: (
      <Badge
        text={statusIndicator.statusText}
        statusColor={statusIndicator.statusType}
      />
    ),
    products: item.payment_link_name ? (
      <strong>{item.payment_link_name}</strong>
    ) : (
      <strong>
        {item.line_items.length && item.line_items[0].product_name}

        {item.line_items.length > 1 &&
          ` + ${item.line_items.length - 1} more item(s)`}
      </strong>
    ),
    date: (
      <span className="date--oneline">
        {moment(item.created_at).format(appConfig.dateTimeFormat)}
      </span>
    ),
    more: (
      <OverflowMenuDropDown
        focusTrap={false}
        data-floating-menu-container
        size="sm"
        flipped
      >
        <OverflowMenuDropDownItem
          index={1}
          itemText="Edit"
          onClick={item.openEditModal}
        />
        <OverflowMenuDropDownItem
          index={2}
          itemText={
            item.status === paymentLinkStatus.active ? "Archive" : "Restore"
          }
          onClick={item.archivePaymentLink}
          hasDivider
        />
        {item.is_delete_locked ? null : (
          <OverflowMenuDropDownItem
            index={3}
            hasDivider={item.status === paymentLinkStatus.deactivated}
            isDelete
            itemText="Delete"
            onClick={item.openDeleteModal}
          />
        )}
      </OverflowMenuDropDown>
    ),
  };
};
